import React from 'react'

export default function Gallery(props) {
  return (
    <div>
      {props.title && <h2 className="LightBox__title">{props.title}</h2>}
      <div className="LightBox__gallery">{props.children}</div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/LightBox/Gallery.js